<template><!-- 更新モーダル -->
<transition name="modal">
  <div class="modal-mask" @click="$emit('close')">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div>
        <CRow>
        <CCol class="scr">
          <table class="table">
            <thead>
              <a style="font-size: 20px"><strong>更新内容確認</strong></a>
              <CCardText><strong>以下の内容で更新してよろしいですか？</strong></CCardText>
            </thead>
            <tbody>
              <tr>
                <td>
                  <a><strong>取引先企業名</strong></a><br>
                  {{ company_name }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>取引先担当者名</strong></a><br>
                  {{ staff_name }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>電話番号</strong></a><br>
                  {{ telephone }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>住所</strong></a><br>
                  {{ address }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>E-Mail</strong></a><br>
                  {{ email }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>支払いサイト</strong></a><br>
                  {{ usance }}(日)
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>備考</strong></a><br>
                  {{ remarks }}
                </td>
              </tr>
            </tbody>
          </table>
        </CCol>
        </CRow>
        <CRow>
          <CCol>
            <button @click="$emit('close')" class="btn btn-secondary">キャンセル</button>
          </CCol>
          <CCol>
            <save-button
              :label="'更新'"
              :loading="loading"
              @click="$emit('update')"
              class="btn btn-primary"
            />
          </CCol>
        </CRow>
        </div>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import SaveButton from '../common/SaveButton'
export default {
  components: { SaveButton },
  name: 'UpdateModal',
  data () {
    return {
    }
  },
  props: {
    company_name: String,
    staff_name: String,
    telephone: String,
    address: String,
    email: String,
    usance: String,
    remarks: String,
    loading: Boolean,
  }
}
</script>

<style scoped>
  .modal-mask {
      position: fixed;
      z-index: 9998;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(80, 80, 80, 0.5);
      display: table;
      transition: opacity .3s ease;
    }
    .modal-wrapper {
      display: table-cell;
      vertical-align: middle;
    }
    .modal-container {
      width: 40%;
      margin: 0px auto;
      padding: 20px 30px;
      background-color: #fff;
      border-radius: 2px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
      transition: all .3s ease;
      font-family: Helvetica, Arial, sans-serif;
    }
    .scr{
      overflow: auto;
    }
</style>
